export default __webpack_public_path__ + "static/media/auth-character-left.d31899aa.png";